import { useCallback, useLayoutEffect, useRef, useState } from 'react';
import './PopupTransition.css';

export const POPUP_TRANSITION_MS = 220;

// Delay the action that removes a popup so its closing scan can finish.
export const usePopupTransition = (
  onClose,
  { open = true, reduceMotion, transitionKey } = {}
) => {
  const reduced =
    reduceMotion ??
    window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches ??
    true;
  const [closing, setClosing] = useState(false);
  const timer = useRef(null);
  const pending = useRef(false);
  const closeRef = useRef(onClose);
  closeRef.current = onClose;
  useLayoutEffect(() => {
    if (open) {
      pending.current = false;
      setClosing(false);
    }
    return () => clearTimeout(timer.current);
  }, [open, transitionKey]);
  const close = useCallback(
    (action) => {
      if (pending.current) return;
      const finish =
        typeof action === 'function' ? action : () => closeRef.current?.();
      pending.current = true;
      if (reduced) {
        finish();
        return;
      }
      setClosing(true);
      timer.current = setTimeout(finish, POPUP_TRANSITION_MS);
    },
    [reduced]
  );
  return {
    close,
    popupClass: `coreboundPopup${closing ? ' is-popup-closing' : ''}`,
    closing,
  };
};
